<template lang="html">
  <section class="news">
    <div class="row">
      <div id='loadingmessage' style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;" v-if="loading">
        <p style="position: absolute; color: White; top: 40%; left: 40%;">
          <img src='../../assets/snakes.gif' /></p>
        </div>
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Edit Rescuer</h4>
            <form class="form-sample" @submit="onSubmit">
              <p class="card-description">
                <strong>Basic info</strong>
              </p>
              <p style="color:red;">{{error}}</p>
              <div class="row">
                <div class="col-md-6">
                  <b-form-group horizontal label="Username">
                    <b-form-input type="text" v-model="username" required=""></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Name">
                    <b-form-input type="text" v-model="name" required=""></b-form-input>
                  </b-form-group>
                  </div>
                   <div class="col-md-6">
                  <b-form-group horizontal label="ID Type">
                    <b-form-input type="text" v-model="idType" required=""></b-form-input>
                  </b-form-group>
                  </div>
                   <div class="col-md-6">
                  <b-form-group horizontal label="Rescuer ID">
                    <b-form-input type="text" v-model="idNumber" required=""></b-form-input>
                  </b-form-group>
                  </div>
                   <div class="col-md-6">
                  <b-form-group horizontal label="Rescuer Code">
                    <b-form-input type="text" v-model="rescuerCode" required=""></b-form-input>
                  </b-form-group>
                  </div>
                  </div>
                       <div class="row">
                          <div class="col-md-6">
                  <b-form-group horizontal label="Email">
                    <b-form-input type="text" v-model="email" required=""></b-form-input>
                  </b-form-group>
                </div>
                    <div class="col-md-6">
                       <b-form-group horizontal label="Phone No">
                   <b-form-input type="text" v-model="phone" required=""></b-form-input>
                   </b-form-group>
                  </div>
                    <div class="col-md-6">
                    <b-form-group horizontal label="Organization">
                    <b-form-input type="text" v-model="organization" required=""></b-form-input>
                  </b-form-group>
                  </div>
                     <div class="col-md-6">
                    <b-form-group horizontal label="Adhar number">
                    <b-form-input type="text" v-model="adharnumber" required=""></b-form-input>
                  </b-form-group>
                  </div>
                   <div class="col-md-6">
                    <b-form-group horizontal label="Blood Group">
                    <b-form-input type="text" v-model="bloodGroup" required=""></b-form-input>
                  </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group horizontal label="Blood Group">
                    <b-form-input type="text" v-model="bloodGroup" required=""></b-form-input>
                  </b-form-group>
                  </div>
                   <div class="col-md-6">
                    <b-form-group horizontal label="District">
                    <b-form-input type="text" v-model="district" required=""></b-form-input>
                  </b-form-group>
                  </div>
                   <div class="col-md-6">
                    <b-form-group horizontal label="Education">
                    <b-form-input type="text" v-model="education" required=""></b-form-input>
                  </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group horizontal label="Rescue Statred at (in years)">
                    <b-form-input type="text" v-model="rescueStartedAt" required=""></b-form-input>
                  </b-form-group>
                  </div>
                    <div class="col-md-6">
                    <b-form-group horizontal label="PermanentAddress">
                    <b-form-input type="text" v-model="permanentAddress" required=""></b-form-input>
                  </b-form-group>
                  </div>
                   <div class="col-md-6">
                    <b-form-group horizontal label="Present Address">
                    <b-form-input type="text" v-model="presentAddress" required=""></b-form-input>
                  </b-form-group>
                  </div>
                    <div class="col-md-6">
                    <b-form-group horizontal label="Employment">
                    <b-form-input type="text" v-model="employment" required=""></b-form-input>
                  </b-form-group>
                  </div>
                   <div class="col-md-6">
                       <b-form-group horizontal label="Disease Status">
                  <b-form-select v-model="diseaseStatus" class="mb-3">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                    </b-form-select>
                   </b-form-group>
                  </div>
                   <div class="col-md-6">
                       <b-form-group horizontal label="Is Rescuer">
                  <b-form-select v-model="is_rescuer" class="mb-3">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                    </b-form-select>
                   </b-form-group>
                  </div>
                    <div class="col-md-6">
                    <b-form-group horizontal label="Is SnakeExpert">
                  <b-form-select v-model="issnakeexpert" class="mb-3">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                    </b-form-select>
                  </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group horizontal label="Is Rescuer Available?">
                  <b-form-select v-model="is_rescuer_Available" class="mb-3">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                    </b-form-select>
                  </b-form-group>
                  </div>
                   <div class="col-md-6">
                       <b-form-group horizontal label="Is District Coordinator">
                  <b-form-select v-model="districtCoordinator" class="mb-3">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                    </b-form-select>
                   </b-form-group>
                  </div>
                  </div>
                <hr>
                <b-button variant="primary" class="btn-fw" type="submit">Update Rescuer Details</b-button>
            </form>
          </div>
          <hr>
          <div class="card-body">
               <h4 class="card-title">Change Password</h4>
               <form class="form-sample" @submit="changePassword">
                   <div class="row">
                <div class="col-md-6">
                  <b-form-group horizontal label="Change Password">
                    <b-form-input type="text" v-model="password" required=""></b-form-input>
                  </b-form-group>
                </div>
                </div>
                 <hr>
                <b-button variant="primary" class="btn-fw" type="submit">Update Password</b-button>
                   </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="js">
import axios from 'axios'
import { VueEditor } from 'vue2-editor'
import Multiselect from 'vue-multiselect'
import vSelect from 'vue-select'
export default {
  name: 'news',
  props: ['id'],
  components: {
    VueEditor,
    Multiselect,
    vSelect
  },
  data () {
    return {
      username: '',
      name: '',
      phone: '',
      email: '',
      error: '',
      loading: false,
      phone: '',
      organization: '',
      is_rescuer: '',
      issnakeexpert: '',
      is_rescuer_Available: '',
      password: '',
      adharnumber:'',
      bloodGroup: '',
      diseaseStatus: '',
      district: '',
      education: '',
      employment: '',
      idNumber: '',
      idType: '',
      permanentAddress: '',
      presentAddress: '',
      rescueStartedAt: '',
      rescuerCode: '',  
      resid: '',
      districtCoordinator:false,
      }
  },
    mounted: function () {
    this.getList()
  },
  methods: {
        getList () {
      this.loading = true
      axios({
       url: 'https://sarpatnapi.leopardtechlabs.in/user/get',
        method: 'GET',
        params: {
            id: this.id
        },
        headers: {
          'x-auth-token': localStorage.getItem('token')
        },
      }).then(response => {
        this.username = response.data.data.username
        this.name = response.data.data.name
        this.email = response.data.data.email
        this.phone = response.data.data.phone
        this.organization = response.data.data.organization
        this.is_rescuer = response.data.data.is_rescuer
        this.issnakeexpert = response.data.data.issnakeexpert
        this.is_rescuer_Available = response.data.data.is_rescuer_Available
        this.adharnumber = response.data.rescuer.adharnumber
      this.bloodGroup = response.data.rescuer.bloodGroup
      this.diseaseStatus = response.data.rescuer.diseaseStatus
      this.district = response.data.rescuer.district
      this.education = response.data.rescuer.education
      this.employment = response.data.rescuer.employment
      this.idNumber = response.data.rescuer.idNumber
      this.idType = response.data.rescuer.idType
      this.permanentAddress = response.data.rescuer.permanentAddress
      this.presentAddress = response.data.rescuer.presentAddress
      this.rescueStartedAt = response.data.rescuer.rescueStartedAt
      this.rescuerCode = response.data.rescuer.rescuerCode
      this.districtCoordinator=response.data.rescuer.districtCoordinator
      this.resid = response.data.rescuer._id
        this.loading = false
      }).catch(e => {
        this.loading = false
      })
    },
    onSubmit (evt) {
      evt.preventDefault()
      this.loading = true
      axios({
        method: 'post',
        url: 'https://sarpatnapi.leopardtechlabs.in/user/adminrescueredit',
        data: {
          id: this.resid,
          name: this.name,
          username: this.username,
          email: this.email,
          phone: this.phone,
          organization: this.organization,
          is_rescuer: this.is_rescuer,
          is_rescuer_Available: this.is_rescuer_Available,
          issnakeexpert: this.issnakeexpert,
          adharnumber: this.adharnumber,
      bloodGroup: this.bloodGroup,
      diseaseStatus: this.diseaseStatus,
      district: this.district,
      education: this.education,
      employment: this.employment,
      idNumber: this.idNumber,
      idType: this.idType,
      permanentAddress: this.permanentAddress,
      presentAddress: this.presentAddress,
      rescueStartedAt: this.rescueStartedAt,
      rescuerCode: this.rescuerCode, 
      districtCoordinator: this.districtCoordinator, 
        },
        headers: {
          'x-auth-token': localStorage.getItem('token')
        }
      })
        .then(response => {
            this.getList();
          alert('Successfully Updated Rescuer Details')
          this.loading = false
        })
        .catch(e => {
          this.loading = false
          this.error = e.response.data.msg
          alert('Failed')
        })
    },
        changePassword (evt) {
      evt.preventDefault()
      this.loading = true
      axios({
        method: 'post',
        url: 'https://sarpatnapi.leopardtechlabs.in/user/editpassword',
        data: {
          id: this.id,
          password: this.password,
        },
        headers: {
          'x-auth-token': localStorage.getItem('token')
        }
      })
        .then(response => {
            this.getList();
          alert('Successfully Updated Password')
          this.loading = false
        })
        .catch(e => {
          this.loading = false
          this.error = e.response.data.msg
          alert('Failed')
        })
    }
  }
}
</script>
<style scoped lang="scss">
#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

#preview img {
  width: 20%;
}
</style>


// WEBPACK FOOTER //
// src/views/forms/editrescuers.vue